<template>
  <qd-collapse
    :open="false"
    position="is-top">
    <template #trigger="props">
        <a class="has-text-default"
          :aria-expanded="props.open">
          <b-icon
          size="is-small"
          :icon="!props.open ? 'chevron-right' : 'chevron-down'">
          </b-icon>
          {{ $t('nomenclatureTechnique.field.nomenclature') }}
        </a>
    </template>
    <div v-for="(value, key) in nomenclature"
      :key="key">
      <span>{{ key }}:</span> <span>{{ formatValue(value) }}</span>
    </div>
  </qd-collapse>
</template>

<script>
export default {
  props: {
    nomenclature: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatValue(value) {
      let val = value;
      if (typeof val === 'boolean') {
        val = val ? this.$t('general.oui') : this.$t('general.non');
      } else if (typeof val === 'number') {
        val = val.toString().replace(/\./g, ',');
      }
      return val;
    },
  },
};
</script>

<style>

</style>
